import React from "react";
import img1 from "../pages/Image/gorilla1.jpg";
import img2 from "../pages/Image/gorilla2.jpg";
import img3 from "../pages/Image/gorilla3.jpg";
import './destination.css'
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';
import SimpleImageSlider from "react-simple-image-slider";
import Swipernew from "./Swipernew";
import slide_image_1 from '../pages/image1/IMG-20240928-WA0013.jpg';
import slide_image_2 from '../pages/image1/IMG-20240928-WA0020.jpg';
import slide_image_3 from '../pages/image1/IMG-20240928-WA0012.jpg';
import slide_image_4 from '../pages/image1/IMG-20240928-WA0023.jpg';

export default function Destination6() {

  const imageArray = [
    slide_image_1,
    slide_image_2,
    slide_image_3,
    slide_image_4,
  
  ];
  return (
    <>
      <div>
      <div>
            <Swipernew images={imageArray} />
        </div>

        <div className=" m-2 pt-5 ">
          <div className="container-fluid">
          <div className="ms-auto me-auto  bg2">

<h1 className="text-center name11  ">
7-Day Discovery Wildlife Tourin Uganda
</h1>
</div>
      
        

          </div>

        </div>

        <div className="container-fluid">
          <Box sx={{ padding: 2 }}>
            <Stepper orientation="vertical" activeStep={8}>
              {steps.map((step, index) => (
                <Step key={step.label1} color="black">
                  {/* Pass label1 to StepLabel */}

                  <StepLabel><h3> {step.label1}</h3></StepLabel>
                  <div className=" bordernew  ">
                    {/* Add the secondary label (optional, shown below the main one) */}
                    <Typography variant="subtitle1" color="textblack" sx={{ ml: 2 }}>
                      <h4><b>{step.label}</b></h4>
                    </Typography>
                    {/* Directly display the description */}
                    <Typography sx={{ mt: 1, mb: 2, ml: 2 }}><h4>&emsp;{step.description}</h4></Typography></div>
                </Step>
              ))}
            </Stepper>
          </Box>



        </div>
        <div class="btn-box text-white text-center">
          <a href="https://wa.me/+971551579904" class="theme-btn btn-style-one rounded-3 m-4 ">Book Now</a>
        </div>
      </div>


    </>
  );
}
const steps = [
  {
    label1: 'Day - 1',
    label: 'Arrival and transfer to your hotel',

    description: `On your arrival at Entebbe International Airport (EBB), you will be received by Japland Tours and Safari staff who will transfer you to your hotel and after check in he/she will brief you about your trip from the next day. After this, you will relax in your hotel as you enjoy the fresh air coming from Lake Victoria. Have a delicious dinner of Uganda’s fresh and yet organic food and an overnight stay as you relax from the jet lag and wait for the next day for a countryside adventure of our beauty.
`,
  },
  {
    label1: 'Day - 2',
    label: 'Drive to Kibale National Park via Fort Portal (Highlights-Chimpanzee)',

    description:
      `  Our driver-guide will pick you pick up from your hotel for a transfer to start your safari. You will be driven westwards via Fort Portal to Kibale Forest National Park taking roughly 5 hours. Traveling on both asphalt and unpaved roads, you pass through traditional Ugandan villages where you see how local indigenous people go around with their daily lives. The lush, rolling hills of this region provide good photo opportunities. You arrive at Fort Portal for lunch, then continue toward Kibale Forest, one of the great African rainforest research reserves. This forest is famous for the variety of primates found here and it is a terrific area for birds. After reaching your accommodation, you may take a rest after a long journey or walk around the lodge.`

  },
  {
    label1: 'Day - 3',
    label: ' Chimpanzee tracking ( Kibale NP) and Bigodi Swamp Walk and transfer to Queen Elizabeth National Park',
    description: (<><p>Assemble at the park headquarters for a briefing and then go for the most popular activity in this park - chimpanzee tracking. Chimpanzees are man’s closest cousins, though they are one of the most threatened primate species. More primates like the black and white colobus monkey, L’Hoest's monkey, grey-cheecked mangabey, red-tailed monkey, bushbaby, and potto. Many bird species like the yellow-spotted nicator, rumped tinker bird, little greenbul, green-breasted pitta, crowned eagle, black bee-eater and mammals like elephants can be seen on this walk. Have lunch and relax at your lodge. Later in the day, you will transfer to the Bigodi Wetlands, situated on the eastern edge of the forest. There, you will take a light walk in the wetlands to observe plenty of wildlife including birds and many monkey species. </p> <p>Later, you will be transfered to Queen Elizabeth National Park where you will view different wild animals en-route as you transfer to the lodge for relaxation.</p></>)
  },
  {
    label1: 'Day - 4',
    label: 'Game drive and afternoon boat cruise at Kazinga Channel',
    description: (<><p>After breakfast, you will go for a game drive - most likely to the Kasenyi plains - which is a famous ground for lions, African elephants, spotted hyenas, and many antelope species including Uganda kobs. Return to the lodge for lunch or have a packed lunch. Late in the afternoon, have a boat cruise on the famous Kazinga Channel. This water body is known for being a catchment for Nile crocodiles, hippos, African elephants, Cape buffalos, and many waterbirds including great white pelicans and great cormorants.</p></>)
  },
  {
    label1: 'Day - 5',
    label: 'Tree-climbing lions in Ishasha and transfer to Bwindi National Park',
    description: (<><p>Transfer through the Ishasha sector of Queen Elizabeth National Park on the way to Bwindi. This area is known for its tree-climbing lions. In Ishasha, we will drive off in this adventurous vast savannah area with topis, African elephants and hopefully get to see the tree-climbing lions high in the fig tree branches. Continue the transfer to Bwindi Impenetrable National Park. Here, you will experience a change in the landscape from flat savanna, via cultivated hills to jungle-covered mountains.</p></>)
  },
  {
    label1: 'Day - 6',
    label: 'Gorilla Tracking in Bwindi Impenetrable Forest - Transfer to Mbarara',
    description: (<><p>You will wake up early morning for breakfast, then assemble at the park headquarters for a briefing about this breathtaking activity, packed lunch included. The time spent on the tracking varies. It depends on where the gorillas spent the night, their feeding range, or encounters with other groups which might be wild, forcing them to move from place to place. Be prepared for a fantastic trek. Once you find them, you spend an hour with them. To see these gentle giants interact is a life time experience. This wildlife encounter in Uganda is truly unforgettable.</p></>)
  },
  {
    label1: 'Day - 7',
    label: 'This marks the end of your 7-day tour in Uganda.',
    description: (<><p> You will have a morning game drive and Transfer to Entebbe International Airport via the equator line.</p><p>After having an early breakfast, go for a morning game drive in Lake Mburo National Park. Lake Mburo National Park is famous for zebras, impalas, giraffes, topis, eland, Cape buffalos and many tropical bird species you will definitely have a wonderful added experience here. After this, check out of the hotel and start your journey with a stopover at the equator line for a short experiment of latitude 0 degrees. </p><p>You will continue to Entebbe International Airport for your late evening flight or drop off to your hotel for your flight the next day. </p><p>Kindly note that your transfer to Entebbe International Airport will still be respected on the day of your flight.</p></>)
  },
];
